/**
 * @generated SignedSource<<22025a05bd4c5824adfd3b7c2aa87820>>
 * @relayHash f54737bfd2a13d4b0794f55692abc45f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5dadc9e02b20435a2eb281b9e0526d9c30d7939933ec6809776a6a63a0bfbfb0

import type { ConcreteRequest } from 'relay-runtime';
export type CompanyHubSpaceQuery$variables = {
  key: string;
};
export type CompanyHubSpaceQuery$data = {
  readonly space: {
    readonly homepageId: string | null;
    readonly id: string | null;
  } | null;
};
export type CompanyHubSpaceQuery = {
  response: CompanyHubSpaceQuery$data;
  variables: CompanyHubSpaceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "key"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "key"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "homepageId"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "CompanyHubSpaceQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CompanyHubSpaceQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f54737bfd2a13d4b0794f55692abc45f",
    "id": "5dadc9e02b20435a2eb281b9e0526d9c30d7939933ec6809776a6a63a0bfbfb0",
    "metadata": {},
    "name": "CompanyHubSpaceQuery",
    "operationKind": "query",
    "text": "query CompanyHubSpaceQuery($key:String!){space(key:$key){id,homepageId}}"
  }
};
})();

(node as any).hash = "27e0b4cea0d06588f669e5b18022e172";

export default node;
